<template>
  
</template>

<script>
  import "./qqmusic_h5"
  export default {
    name: '',
    data() {
      return {
        
      }
    },
    methods:{},
    created(){
      this.$emit('initPlayer', new window.Player())
    }
  }
</script>

<style lang="" scoped>
  
</style>